// eslint-disable-next-line import/prefer-default-export
export const USER_TYPE = 'int-admin-user-type';
